import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import Modal from '../../../../components/Modal/Modal';
import { SectionButton } from '../../styles/GerenciarContas.styles';
import Button from '../../../../components/Button/Button';
import { useMemo, useRef, useEffect, useState } from 'react';
import * as S from './MakeTransfer.styles';
import { performRepaseLote } from '../../../../store/fetchActions/transactionsActions';
import TextField from '../../../../components/TextField';
import { useTheme } from 'styled-components';
import InputFormat from '../InputFormat';
import { accountsApprovedFetchAction } from '../../../../store/fetchActions/userAccounts';
import { Autocomplete } from '@mui/material';

const RepaseLote = ({ openModal, closeModal, idConta, transactionIds, valorTotal }) => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const [idContaDestino, setIDContaDestino] = useState();

  const { detailAccountsData } = useSelector((state) => state.account);
  const { loading } = useSelector((state) => state.spreadTransaction);
  const { usersData } = useSelector((state) => state.user);
  const accountsApproved = useSelector((state) => state.userAccounts?.approvedAccountsData || []);

  const { handleSubmit, control, setValue } = useForm({});

  const contas = useMemo(() => {
    if (!accountsApproved || !Array.isArray(accountsApproved)) return [];
    return accountsApproved.map((val) => ({
      ID: val.ID,
      NOME: `${val.ID} - ${val.NOME} - ${val.CONTA}`,
    }));
  }, [accountsApproved]);

  useEffect(() => {
    dispatch(accountsApprovedFetchAction({ PAGE: 1, LIMIT: 1000 }));
  }, [dispatch]);

  useEffect(() => {
    const num = Number(valorTotal);
    if (num) {
      const parts = num.toFixed(4).split('.');
      const intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      setValue('valor', `R$${intPart},${parts[1]}`);
    }
  }, [valorTotal, setValue]);

  const submitRepase = (data) => {
    const valorNumero = data.valor.replace('R$', '').replace(/\./g, '').replace(',', '.').trim();
    if (!valorNumero || valorNumero === '0.00') {
      return;
    }
    const params = {
      ID_CONTA: idConta,
      ID_CONTA_DESTINO: idContaDestino,
      VALOR: data.valor.replace('R$', '').replace(/\s/g, ''),
      CPFCNPJ_DESTINO: detailAccountsData?.cliente?.CPFCNPJ,
      CPFCNPJ_CLIENTE: usersData?.CPFCNPJ,
      TRANSACTION_IDS: transactionIds,
    };
    dispatch(performRepaseLote(params, closeModal));
  };

  const autoC = useRef(null);

  return (
    <Modal open={openModal} close={closeModal} title={'Repasse em Lote'} width={'40vw'}>
      <form onSubmit={handleSubmit(submitRepase)}>
        <S.FormSectionInput>
          <S.ConteinerInput>
            <Autocomplete
              ref={autoC}
              options={contas}
              width={'100%'}
              getOptionLabel={(option) => option.NOME}
              noOptionsText={'Sem opções'}
              onChange={(event, newValue) => {
                setIDContaDestino(newValue?.ID);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Conta Destino"
                  variant="outlined"
                  control={control}
                  name={'autocomplete'}
                />
              )}
            />
          </S.ConteinerInput>
          <S.ConteinerInput>
            <InputFormat
              control={control}
              formatType={'currency'}
              label={'Valor do repasse'}
              width={'100%'}
              name={'valor'}
              required={true}
              decimalPlaces={4}
            />
          </S.ConteinerInput>
        </S.FormSectionInput>
        <SectionButton>
          <Button
            backgroundcolor={theme.colors.darklimeGreen}
            width={'100%'}
            height={'3.125vw'}
            hoverbgcolor={theme.colors.darklimeGreen}
            hovercolor={theme.colors.white}
            mycolor={theme.colors.white}
            type={'submit'}
            disabled={loading}
          >
            <span>Repassar</span>
          </Button>
        </SectionButton>
      </form>
    </Modal>
  );
};

export default RepaseLote;
